import { graphql } from "../generated"

// Common/shared queries used across multiple domains

export const GetPresignedUrlForXml = graphql(`
  query GetPresignedUrlForXml($fileStore: String!, $key: String!) {
    getPresignedUrl(fileStore: $fileStore, key: $key)
  }
`)

export const listFeatureFlags = graphql(`
  query listFeatureFlags {
    getFeatureFlags
  }
`)

export const getDfeFormConfig = graphql(`
  query GetDfeFormConfig(
    $templateId: ID!
    $templateVersionId: ID!
    $recipeType: RecipeType
  ) {
    getDfeForm(
      input: {
        templateId: $templateId
        templateVersionId: $templateVersionId
        recipeType: $recipeType
      }
    ) {
      config
    }
  }
`)

export const getActiveTemplateBySubmissionLayout = graphql(`
  query getActiveTemplateBySubmissionLayout(
    $submissionLayout: SubmissionLayoutType!
  ) {
    getActiveTemplateBySubmissionLayout(submissionLayout: $submissionLayout) {
      templateId
      templateVersionId
    }
  }
`)

export const getRequestPartyRoles = graphql(`
  query FetchRequestPartyRoles(
    $requestId: ID!
    $requestType: CoreRequestType!
  ) {
    fetchRequestPartyRoles(
      input: { requestId: $requestId, requestType: $requestType }
    ) {
      highestPartyRole
      partyRoles
    }
  }
`)

export const getTemplateWithApprovedVersion = graphql(`
  query GetTemplateWithApprovedVersion($templateId: ID!) {
    getTemplateWithActiveApproved(templateId: $templateId) {
      id
      approvedVersion {
        id
      }
    }
  }
`)

export const queryValidate = graphql(`
  query queryValidate($id: ID!) {
    validate(id: $id) {
      error
      path
      type
    }
  }
`)

export const GetRequestValidations = graphql(`
  query GetRequestValidations($input: GetRequestValidationsInput!) {
    getRequestValidations(input: $input) {
      errors {
        errorType
        field
        fieldFuid
        id
        message
        errorMsg
        maxLength
        fieldValue
        additionalFieldValue
        additionalFuid
        type
        details
      }
      warnings {
        errorType
        field
        fieldFuid
        id
        message
        errorMsg
        maxLength
        fieldValue
        additionalFieldValue
        additionalFuid
        type
        details
      }
    }
  }
`)

export const downloadSubmissionXMLQuery = graphql(`
  query downloadSubmissionXML($id: ID!, $requestType: CoreRequestType!) {
    downloadSubmissionXML(requestId: $id, requestType: $requestType) {
      fileName
      url
    }
  }
`)

export const downloadOutputXMLQuery = graphql(`
  query downloadOutputXML($id: ID!) {
    downloadOutputXML(exportRequestId: $id) {
      fileName
      url
    }
  }
`)

export const checkUserAccessQuery = graphql(`
  query checkUserAccess($input: CheckUserAccessInput!) {
    checkUserAccess(input: $input) {
      allowed
      message
    }
  }
`)

export const getConsignorDetails = graphql(`
  query getConsignorDetails($id: ID!, $requestId: ID) {
    getConsignorDetails(id: $id, requestId: $requestId) {
      physicalAddress
      name
      identifiers {
        id
        status
        type
      }
    }
  }
`)

export const querySfExporter = graphql(`
  query querySfExporter($id: ID!, $certificateType: CertificateType) {
    sfExporter(id: $id, certificateType: $certificateType) {
      addresses {
        addressType
        city
        country
        street
        postalCode
        isPrimary
      }
      nzbn
      name
      id
      registrationNumber
      contacts {
        emails {
          emailAddress
          isPrimary
        }
        name
        phones {
          telephoneNumber
          isPrimary
        }
        role
      }
      identifiers {
        value
        id
        description
      }
    }
  }
`)

export const getSnapshotPresignedUrl = graphql(`
  query GetSnapshotPresignedUrl($historyId: ID!) {
    getSnapshotPresignedUrl(historyId: $historyId) {
      url
    }
  }
`)

export const queryCertificates = graphql(`
  query FindAvailableTemplates($commodity: String!, $countryCode: String!) {
    availableTemplates(commodity: $commodity, countryCode: $countryCode) {
      id
      code
      title
      exportCertificateType
      commodity
      destinationMarket
      displayedDescription
      minorVersion
      majorVersion
    }
  }
`)
